import { render, staticRenderFns } from "./VGrid.vue?vue&type=template&id=ec64b31c&"
import script from "./VGrid.vue?vue&type=script&lang=js&"
export * from "./VGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports